import React from "react";
import { NavLink } from "react-router-dom";

function Section_1() {
  return (
    <section className="csrd-landing-page-section-1-container">
      <div className="csrd-banner">
        <img
          src={require("../../../assets/landing/csrd_landing/csrd_banner.webp")}
          width="100%"
          alt="csrd-banner-main-image"
          className="csrd-banner-main-image"
          loading="lazy"
        />
        <div className="csrd-banner-left-section">
          <div className="csrd-banner-logo-container">
            <img
              src={require("../../../assets/landing/csrd_landing/csrd_updapt_logo.svg")}
              alt="csrd-updapt-logo"
              className="csrd-banner-logo"
            />
          </div>
          <div className="csrd-banner-header-container">
            <div className="csrd-banner-header-1-container">CSRD Reporting Made Simple.</div>
            <div className="csrd-banner-header-1-container">Stay Confident and Compliant with</div>
            <div className="csrd-banner-header-2-container">
              Updapt’s AI-Powered CSRD Reporting Software.
            </div>
          </div>
          <div className="csrd-banner-description">
            The Corporate Sustainability Reporting Directive (CSRD) establishes a new standard for
            sustainability disclosures across the EU, ensuring companies report in alignment with
            the European Sustainability Reporting Standards (ESRS). Updapt simplifies this
            process—bringing automation, AI, and XBRL compliance into one seamless platform.
          </div>
          <div className="csrd-banner-demo-button-container">
            <button className="banner-demo">
              <NavLink to="/demo" className="home-banner-get-started-btn">
                Book a Demo Now
              </NavLink>
            </button>
          </div>
        </div>
        <div className="csrd-banner-right-section"></div>
      </div>
    </section>
  );
}

export default Section_1;
